import { commonStrings } from "@src/constants/common-strings";
import { MainRoutes } from "@router/route-params";
import { RequiredFeatureCompanyLevelName } from "@utils/feature-control/company/company-feature-control-types";
import { SettingsIcon, AnalyticsIcon, GroupsIcon, MembersIcon, ProjectsIcon } from "@flat-ui";

/**
 * All the items that can be seen in the sidebar.
 * The reason this was changed from an enum to a type is that typescript enums do not support
 * strings from variables (const or not)
 */

/** The items to show in the top of the sidebar */
export const SidebarItems = [{
  identity: commonStrings.PROJECTS,
  icon: <ProjectsIcon />,
  title: commonStrings.PROJECTS,
  route: MainRoutes.projects,
  dataTestId: "SIDEBAR_PROJECT_BUTTON",
  requiredFeatureCompanyLevel: RequiredFeatureCompanyLevelName.canViewProjects
}, {
  identity: commonStrings.MEMBERS,
  icon: <MembersIcon />,
  title: commonStrings.MEMBERS,
  route: MainRoutes.members,
  dataTestId: "SIDEBAR_USER_DIRECTORY_BUTTON",
  requiredFeatureCompanyLevel: RequiredFeatureCompanyLevelName.canViewCompanyMembers
}, {
  identity: commonStrings.GROUPS,
  icon: <GroupsIcon />,
  title: commonStrings.GROUPS,
  route: MainRoutes.groups,
  dataTestId: "SIDEBAR_GROUPS_BUTTON",
  requiredFeatureCompanyLevel: RequiredFeatureCompanyLevelName.canViewCompanyGroups
}, {
  identity: commonStrings.ANALYTICS,
  icon: <AnalyticsIcon />,
  title: commonStrings.ANALYTICS,
  route: MainRoutes.analytics,
  dataTestId: "SIDEBAR_ANALYTICS_BUTTON",
  requiredFeatureCompanyLevel: RequiredFeatureCompanyLevelName.canViewAnalytics
}, {
  identity: commonStrings.SETTINGS,
  icon: <SettingsIcon />,
  title: commonStrings.SETTINGS,
  route: MainRoutes.settings,
  dataTestId: "SIDEBAR_WORKSPACE_SETTINGS_BUTTON",
  requiredFeatureCompanyLevel: RequiredFeatureCompanyLevelName.canViewWorkspaceSettings
}];